module.exports = __webpack_public_path__ + "img/cabbage.a0e1763e.jpg";